import { moduleName, performVKMethod } from './index'

export default {
	[moduleName + performVKMethod.response_type]: performVKMethod.reducer
}
